const form = document.querySelector('form#mobileFilters');

form.addEventListener('change', (e) => {
    const { value } = e.target;
    let url = window.blogUrl;

    if (value !== 'all') {
        url = window.blogUrl + `/tagged/${value}`;
    }

    window.location.href = url;
});